import React from 'react';
import { MenuItem as MenuItemType } from '../data/menu';
import MenuItem from './MenuItem';

interface MenuSectionProps {
  title: string;
  items: MenuItemType[];
  id: string;
}

const MenuSection: React.FC<MenuSectionProps> = ({ title, items, id }) => {
  if (items.length === 0) return null;

  return (
    <div id={id} className="py-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex items-center mb-10">
          <div className="h-1 w-10 bg-orange-500 rounded-full mr-4"></div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800">{title}</h2>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {items.map((item) => (
            <MenuItem key={item.id} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MenuSection;
